import { Component, OnInit, Input, Output } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.css']
})
export class ToggleComponent implements OnInit {
@Input() label : string;
@Input() model : boolean;
@Input() name : string;
@Output() modelChanged = new Subject<any>();

  constructor() { }

  ngOnInit() {
  }

  modelChange(){
    this.model = !this.model;
    this.modelChanged.next({
      name: this.name,
      value: this.model
    })
  }
}
